import { LienholderResponse } from '@app-model/checkout/submit_cart/response/lienholder.response';

export class CheckoutFormValues {
  customer: {};
  cosigner: {};
  vehicle: {};
  lienholder: {
    lienholder: LienholderResponse;
    noLienholder: 'YES' | 'NO';
  };
  customerFormValid: boolean;
  cosignerFormValid: boolean;
  vehicleFormValid: boolean;
  lienholderFormValid: boolean;

  constructor() {
    this.customer = {};
    this.cosigner = {};
    this.vehicle = {};
    this.lienholder = {
      lienholder: {} as LienholderResponse,
      noLienholder: 'YES',
    };
    this.customerFormValid = false;
    this.cosignerFormValid = false;
    this.vehicleFormValid = false;
    this.lienholderFormValid = false;
  }
}
